/**
 * Custom filter for cmdk that uses substring matching instead of the
 * default fuzzy algorithm. Scoring tiers:
 *
 *   1.0 — label starts with search term (prefix match)
 *   0.8 — label contains search term (substring match)
 *   0.7 — every search word appears in the label (multi-word)
 *   0.5 — keywords contain the full search term
 *   0.4 — every search word appears across label + keywords
 *   0   — no match (item hidden by cmdk)
 *
 * This prevents unrelated items from appearing above exact matches,
 * which cmdk's built-in fuzzy algorithm does poorly.
 */
export function commandPaletteFilter(value: string, search: string, keywords?: string[]): number {
    const v = value.toLowerCase();
    const s = search.toLowerCase();
    if (!s) return 1;

    // Check label: prefix match scores highest
    if (v.startsWith(s)) return 1;
    // Substring match in label
    if (v.includes(s)) return 0.8;

    // Check each search word individually against label
    const words = s.split(/\s+/).filter(Boolean);
    if (words.length > 1 && words.every((w) => v.includes(w))) return 0.7;

    // Check keywords
    if (keywords) {
        const kw = keywords.join(" ").toLowerCase();
        if (kw.includes(s)) return 0.5;
        if (words.length > 1 && words.every((w) => kw.includes(w) || v.includes(w))) return 0.4;
    }

    return 0;
}
